"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFiltersSection = exports.renderActiveFilters = void 0;
var _react = _interopRequireDefault(require("react"));
var _Chip = _interopRequireDefault(require("../../components/Chip/Chip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const renderActiveFilters = (activeFilters, removeActiveFilterHandler) => {
  return activeFilters?.map((filter, i) => {
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      key: i,
      isSelected: false,
      removeChipClickHandler: e => removeActiveFilterHandler(e, filter),
      label: filter?.name
    });
  });
};
exports.renderActiveFilters = renderActiveFilters;
const renderFiltersSection = (allFilters, filterDropdownClickHandler, filterOptionClickHandler, openFilterDropdown, activeFilters, handleOptionHover, hoveredItem) => {
  const filterIsChecked = (activeFilters, option) => {
    return activeFilters?.some(filter => filter?.id === option?.id);
  };
  return allFilters?.map((filter, i) => {
    if (filter?.options?.length > 0) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: i,
        className: "ter-filter-section__filter-wrapper"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "ter-filter-section__filter-title"
      }, filter?.name), /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-filter-section__filter-placeholder",
        onClick: e => filterDropdownClickHandler(e, filter?.id)
      }, /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "11",
        fill: "currentColor",
        className: `ter-filter-section__chevron ${openFilterDropdown === filter?.id ? 'ter-filter-section__chevron--open' : ''}`,
        role: "img",
        "aria-label": "dropdown chevron icon"
      }, /*#__PURE__*/_react.default.createElement("path", {
        fill: "currentColor",
        d: "M1.88.453 8 6.56 14.12.453 16 2.333l-8 8-8-8L1.88.453Z"
      })), /*#__PURE__*/_react.default.createElement("span", null, "Select")), /*#__PURE__*/_react.default.createElement("div", {
        className: `ter-filter-section__filter-list ${openFilterDropdown === filter?.id ? 'ter-filter-section__filter-list--open' : ''}`
      }, filter?.options?.map((option, i) => {
        const optionAttributes = {
          name: option?.name,
          checked: filterIsChecked(activeFilters, option)
        };
        return /*#__PURE__*/_react.default.createElement("div", {
          className: `ter-filter-section__filter-option ${hoveredItem === option.name ? 'ter-filter-section__filter-option--hovered' : ''}`,
          key: i,
          "aria-label": option?.name,
          onMouseOver: e => handleOptionHover(e, option?.name),
          onMouseLeave: e => handleOptionHover(e, null)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: `ter-checkbox ${optionAttributes?.checked ? 'is-checked' : ''}`
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: `ter-checkbox__label ter-filter-section__filter-label`,
          style: {
            color: "#242D2F"
          }
        }, /*#__PURE__*/_react.default.createElement("input", _extends({}, optionAttributes, {
          id: option?.name,
          type: "checkbox",
          onChange: e => {
            e.stopPropagation();
            filterOptionClickHandler(e, option);
          }
        })), option?.name)));
      })));
    } else {
      return null;
    }
  });
};
exports.renderFiltersSection = renderFiltersSection;